<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.procedure_evidence.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
      :state="validateState('description')"
    >
      <div
        class="form-description mb-2"
        :class="{ 'is-invalid': validateState('description') === false }"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="procedure_evidence.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="procedure_evidence"
        :content_rich_text="procedure_evidence.description"
        :show_last_modification="true"
        @save="(content) => patchDescription(procedure_evidence, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="procedure_evidence"
          :Text="procedure_evidence.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback
        id="input-description-live-feedback"
        :state="validateState('description')"
      >
        {{ $t("reusable.common.required") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(procedure_evidence.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2 mb-2"
    >
      <ModificationDate :Information="procedure_evidence"></ModificationDate>
    </b-form-group>

    <div class="row">
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";

export default {
  name: "ProcedureEvidenceForm",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  mixins: [validationMixin],
  props: {
    ProcedureEvidence: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          institution: "",
          active: true,
          creation_date: null,
          created_by: null,
          update_date: null,
          updated_by: null,
        };
      },
    },
    institution_id: {
      type: Number,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      procedure_evidence: this.ProcedureEvidence,
    };
  },
  validations: {
    procedure_evidence: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {
        required,
        minLength: minLength(5),
      },
    },
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.procedure_evidence[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.procedure_evidence.$touch();
      if (this.$v.procedure_evidence.$anyError) {
        return;
      }
      if (isNaN(this.procedure_evidence.id)) {
        this.createProcedureEvidence();
      } else this.updateProcedureEvidence();
    },
    patchDescription(object, text) {
      this.procedure_evidence.description = text;
    },
    createProcedureEvidence() {
      this.procedure_evidence.school = this.institution_id;
      this.$store
        .dispatch(
          names.POST_PROCEDURE_EVIDENCE,
          this.procedure_evidence,
          this.procedure_evidence.school
        )
        .then((response) => {
          toast(this.$t("toolbar.procedureEvidence.evidenceCreated"));
          this.$emit("created", response);
        });
    },
    updateProcedureEvidence() {
      this.procedure_evidence.school = this.institution_id;
      this.$store
        .dispatch(
          names.UPDATE_PROCEDURE_EVIDENCE,
          this.procedure_evidence,
          this.procedure_evidence.school
        )
        .then((response) => {
          toast(this.$t("toolbar.procedureEvidence.evidenceUpdated"));
          this.$emit("updated", response);
        });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description.is-invalid {
  border-color: #dc3545;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>